import defaultTheme from './defaultTheme';
const atHomeTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#083355', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#083355', background: '#083355' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#083355' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#083355', border: '#083355', background: '#083355' }), field: {
        focus: '#083355',
        label: '#083355',
        icon: '#083355',
    } });
export default atHomeTheme;
